import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IStressSituationResponse,
} from "models/stressCheck/stressSituation";
import { httpStatus } from "configs/httpStatus";
import { getStressSituation } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./stressSituationActions";

function* stressSituationSaga() {
  try {
    const response: IStressSituationResponse = yield call(getStressSituation);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}

function* onGetStressSituationWatcher() {
  yield takeLatest(ActionType.STRESS_SITUATION as any, stressSituationSaga);
}

export default [fork(onGetStressSituationWatcher)];
